import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=4f4c8362&scoped=true&"
import script from "./transfer.vue?vue&type=script&lang=js&"
export * from "./transfer.vue?vue&type=script&lang=js&"
import style0 from "./transfer.vue?vue&type=style&index=0&id=4f4c8362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4c8362",
  null
  
)

export default component.exports